module.exports = __webpack_public_path__ + "img/record-empty.504f674d.png";